import {
    FETCH_PARTNERS_REQUEST,
    FETCH_PARTNERS_SUCCESS,
    FETCH_PARTNERS_FAILURE,
    FETCH_PARTNER_BY_ID_REQUEST,
    FETCH_PARTNER_BY_ID_SUCCESS,
    FETCH_PARTNER_BY_ID_FAILURE,
    CREATE_PARTNER_REQUEST,
    CREATE_PARTNER_SUCCESS,
    CREATE_PARTNER_FAILURE,
    RESET_CREATE_PARTNER,
    UPDATE_PARTNER_REQUEST,
    UPDATE_PARTNER_SUCCESS,
    UPDATE_PARTNER_FAILURE,
    RESET_UPDATE_PARTNER,
    DELETE_PARTNER_REQUEST,
    DELETE_PARTNER_SUCCESS,
    DELETE_PARTNER_FAILURE,
    CREATE_PARTNER_ACCOUNT_REQUEST,
    CREATE_PARTNER_ACCOUNT_SUCCESS,
    CREATE_PARTNER_ACCOUNT_FAILURE,
} from '../actions/partnerActions';

const initialState = {
    partners: {
        data: null,
        loading: false,
        error: null,
    },
    selectedPartner: {
        data: null,
        loading: false,
        error: null,
    },
    create: {
        loading: false,
        error: null,
        success: false,
        data: null,
    },
    update: {
        loading: false,
        error: null,
        success: false,
        data: null,
    },
    delete: {
        loading: false,
        error: null,
        success: false,
    },
    createAccount: {
        loading: false,
        error: null,
        success: false,
    },
};

const partnerReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PARTNERS_REQUEST:
            return {
                ...state,
                partners: {
                    ...state.partners,
                    loading: true,
                    error: null,
                },
            };

        case FETCH_PARTNERS_SUCCESS:
            return {
                ...state,
                partners: {
                    data: action.payload,
                    loading: false,
                    error: null,
                },
            };

        case FETCH_PARTNERS_FAILURE:
            return {
                ...state,
                partners: {
                    ...state.partners,
                    loading: false,
                    error: action.payload,
                },
            };

        case FETCH_PARTNER_BY_ID_REQUEST:
            return {
                ...state,
                selectedPartner: {
                    ...state.selectedPartner,
                    loading: true,
                    error: null,
                },
            };

        case FETCH_PARTNER_BY_ID_SUCCESS:
            return {
                ...state,
                selectedPartner: {
                    data: action.payload,
                    loading: false,
                    error: null,
                },
            };

        case FETCH_PARTNER_BY_ID_FAILURE:
            return {
                ...state,
                selectedPartner: {
                    ...state.selectedPartner,
                    loading: false,
                    error: action.payload,
                },
            };

        case CREATE_PARTNER_REQUEST:
            return {
                ...state,
                create: {
                    loading: true,
                    error: null,
                    success: false,
                    data: null,
                },
            };

        case CREATE_PARTNER_SUCCESS: {
            // Helper function to extract partners array
            const getPartnersArrayForCreate = (data) => {
                if (!data) return [];
                if (Array.isArray(data)) return data;
                if (Array.isArray(data.users)) return data.users;
                if (Array.isArray(data.partners)) return data.partners;
                if (Array.isArray(data.data)) return data.data;
                return [];
            };

            const createdPartner = action.payload?.partner || action.payload;
            const existingPartners = getPartnersArrayForCreate(state.partners.data);
            const newPartnersArray = createdPartner
                ? [...existingPartners, createdPartner]
                : existingPartners;

            // Preserve the original structure if it wasn't a simple array
            let newData = newPartnersArray;
            if (state.partners.data && !Array.isArray(state.partners.data)) {
                if (state.partners.data.users) {
                    newData = { ...state.partners.data, users: newPartnersArray };
                } else if (state.partners.data.partners) {
                    newData = { ...state.partners.data, partners: newPartnersArray };
                } else if (state.partners.data.data) {
                    newData = { ...state.partners.data, data: newPartnersArray };
                }
            }

            return {
                ...state,
                create: {
                    loading: false,
                    error: null,
                    success: true,
                    data: action.payload,
                },
                partners: {
                    ...state.partners,
                    data: newData,
                },
            };
        }

        case CREATE_PARTNER_FAILURE:
            return {
                ...state,
                create: {
                    loading: false,
                    error: action.payload,
                    success: false,
                    data: null,
                },
            };

        case RESET_CREATE_PARTNER:
            return {
                ...state,
                create: {
                    loading: false,
                    error: null,
                    success: false,
                    data: null,
                },
            };

        case UPDATE_PARTNER_REQUEST:
            return {
                ...state,
                update: {
                    loading: true,
                    error: null,
                    success: false,
                    data: null,
                },
            };

        case UPDATE_PARTNER_SUCCESS: {
            // Helper function to extract partners array from various data structures
            const getPartnersArray = (data) => {
                if (!data) return [];
                if (Array.isArray(data)) return data;
                if (Array.isArray(data.users)) return data.users;
                if (Array.isArray(data.partners)) return data.partners;
                if (Array.isArray(data.data)) return data.data;
                return [];
            };

            const partnersArray = getPartnersArray(state.partners.data);
            const updatedPartners = partnersArray.map((partner) => {
                const partnerId = partner.user_uuid || partner.id || partner.partner_id;
                const payloadId = action.payload?.user?.user_uuid || action.payload?.user_uuid || action.payload?.id || action.payload?.partner_id;
                return partnerId === payloadId ? (action.payload?.user || action.payload) : partner;
            });

            // Preserve the original structure if it wasn't a simple array
            let updatedData = updatedPartners;
            if (state.partners.data && !Array.isArray(state.partners.data)) {
                if (state.partners.data.users) {
                    updatedData = { ...state.partners.data, users: updatedPartners };
                } else if (state.partners.data.partners) {
                    updatedData = { ...state.partners.data, partners: updatedPartners };
                } else if (state.partners.data.data) {
                    updatedData = { ...state.partners.data, data: updatedPartners };
                }
            }

            return {
                ...state,
                update: {
                    loading: false,
                    error: null,
                    success: true,
                    data: action.payload,
                },
                partners: {
                    ...state.partners,
                    data: updatedData,
                },
                selectedPartner: {
                    data: action.payload?.user || action.payload,
                    loading: false,
                    error: null,
                },
            };
        }

        case UPDATE_PARTNER_FAILURE:
            return {
                ...state,
                update: {
                    loading: false,
                    error: action.payload,
                    success: false,
                    data: null,
                },
            };

        case RESET_UPDATE_PARTNER:
            return {
                ...state,
                update: {
                    loading: false,
                    error: null,
                    success: false,
                    data: null,
                },
            };

        case DELETE_PARTNER_REQUEST:
            return {
                ...state,
                delete: {
                    loading: true,
                    error: null,
                    success: false,
                },
            };

        case DELETE_PARTNER_SUCCESS:
            // Helper function to extract partners array
            const getPartnersArrayForDelete = (data) => {
                if (!data) return [];
                if (Array.isArray(data)) return data;
                if (Array.isArray(data.users)) return data.users;
                if (Array.isArray(data.partners)) return data.partners;
                if (Array.isArray(data.data)) return data.data;
                return [];
            };

            const partnersForDelete = getPartnersArrayForDelete(state.partners.data);
            const filteredPartners = partnersForDelete.filter((partner) => {
                const partnerId = partner.user_uuid || partner.id || partner.partner_id;
                return partnerId !== action.payload;
            });

            // Preserve the original structure if it wasn't a simple array
            let filteredData = filteredPartners;
            if (state.partners.data && !Array.isArray(state.partners.data)) {
                if (state.partners.data.users) {
                    filteredData = { ...state.partners.data, users: filteredPartners };
                } else if (state.partners.data.partners) {
                    filteredData = { ...state.partners.data, partners: filteredPartners };
                } else if (state.partners.data.data) {
                    filteredData = { ...state.partners.data, data: filteredPartners };
                }
            }

            return {
                ...state,
                delete: {
                    loading: false,
                    error: null,
                    success: true,
                },
                partners: {
                    ...state.partners,
                    data: filteredData,
                },
            };

        case DELETE_PARTNER_FAILURE:
            return {
                ...state,
                delete: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            };

        case CREATE_PARTNER_ACCOUNT_REQUEST:
            return {
                ...state,
                createAccount: {
                    loading: true,
                    error: null,
                    success: false,
                },
            };

        case CREATE_PARTNER_ACCOUNT_SUCCESS:
            return {
                ...state,
                createAccount: {
                    loading: false,
                    error: null,
                    success: true,
                },
            };

        case CREATE_PARTNER_ACCOUNT_FAILURE:
            return {
                ...state,
                createAccount: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            };

        default:
            return state;
    }
};

export default partnerReducer;

